import React, { forwardRef } from 'react';
import { Grid, Typography } from '@mui/material';
import { useQuery } from '../../_hooks/useQuery';
import BrowserItem from './BrowserItem';
import { selectTitleTypes } from '@/redux/selectors/constantsSelectors';
import { TitleEntity } from '@/redux/slices/slice_types';
import styled from '@emotion/styled';
import { useAppSelector } from '@/redux/hooks';

type BrowserSeasonProps = {
  season: TitleEntity;
  episodeSelected?: any;
  onSeasonClick: (season: any) => void;
};

const BrowserSeason = ({ season, episodeSelected, onSeasonClick }: BrowserSeasonProps, ref: any) => {
  const typeMap = useAppSelector(selectTitleTypes);
  const query = useQuery();
  const seasonId = query.get('season_id');
  const episodeId = query.get('episode_id');
  const isActive = !episodeId && Number(seasonId) == season.id;
  const showChildren = season.children?.[0]?.entity_type !== 'version';
  const isSeason = season.entity_type === 'season';

  const getChildrenType = (season: TitleEntity) => {
    const childCount = season.children?.length || 0;
    const isPlural = childCount > 1;
    
    if (season.entity_type === 'marketing' || 
        !season.children?.every(child => child?.entity_type === season.children[0]?.entity_type)) {
      return isPlural ? 'children' : 'child';
    }
    
    const childType = typeMap[season.children[0]?.entity_type as keyof typeof typeMap]?.toLowerCase();
    return childType ? `${childType}${isPlural ? 's' : ''}` : (isPlural ? 'children' : 'child');
  };

  const childrenType = getChildrenType(season);

  return (
    <Season ref={ref}>
      <BrowserItem active={isActive} activeParent={episodeSelected} onClick={() => onSeasonClick(season.id)}>
        <Grid container alignItems="center" flexWrap="nowrap">
          <Grid item sx={{ ml: 1, maxWidth: '80%', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {isSeason && (
              <Typography variant="subtitle2" sx={{ mr: 1 }}>
                S{season.sequence_order}:
              </Typography>
            )}
            {season.name}{' '}
            <Typography variant="caption" sx={{ ml: 1, fontSize: '.8rem' }}>
              {season.meta?.characteristics?.release_year}
            </Typography>
          </Grid>

          <Grid item sx={{ ml: 'auto', mr: 1 }}>
            {showChildren && season.children.length ? (
              <Typography variant="caption" sx={{ fontSize: '.9rem' }}>
                {season.children.length} {childrenType}
              </Typography>
            ) : <></>}
          </Grid>
        </Grid>
      </BrowserItem>
    </Season>
  );
};

export default forwardRef(BrowserSeason);

const Season = styled.div`
  position: relative;
`;
